import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=950b3806&"
import script from "./article-detail.vue?vue&type=script&lang=js&"
export * from "./article-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports